/* eslint-disable prettier/prettier */
import css from 'styled-jsx/css';

export const faqItemCss = css`
  @function rem($size) {
    $remSize: calc($size / 16);
    @return #{$remSize}rem;
  }

  .faq-item {
    padding: rem(5) rem(10);
    position: relative;
    /* border-bottom: 1px solid var(--color-gp--grey2); */

    &--with-borders {
      border: 1px solid var(--color-gp--grey2);
    }

    &--with-bottom-border {
      padding: rem(16) rem(5);
      border-bottom: 2px solid var(--color-gp--grey2);
    }

    .clicable-gap {
      :global(.item_link) {
        width: 100%;
      }
    }

    &__header {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .faq-item__title {
        max-width: calc(100% - 26px);
      }
      .faq-item__chevron-icon {
        width: rem(16);
        height: rem(16);
        transform: rotate(0deg);
        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -o-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;

        &--opened {
          transform: rotate(180deg);
          height: rem(16);
          -webkit-transition: all 0.3s ease-out;
          -moz-transition: all 0.3s ease-out;
          -o-transition: all 0.3s ease-out;
          transition: all 0.3s ease-out;
        }
      }
    }

    &__content {
      height: 0;
      opacity: 0;
      overflow: hidden;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      transition: all 0.3s ease-out;

      &--opened {
        padding: rem(8) 0px rem(10);
        height: auto;
        opacity: 1;
        -webkit-transition: all 0.3s ease-out;
        -moz-transition: all 0.3s ease-out;
        -o-transition: all 0.3s ease-out;
        transition: all 0.3s ease-out;
      }
    }
    :global(a) {
      color: var(--color-gp--blue);
      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
